import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      {/* Header */}
      <div className="border-b border-white/10 bg-black/50 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors"
          >
            <i className="ri-arrow-left-line"></i>
            <span>戻る</span>
          </Link>
          <div className="text-xs text-white/40">最終更新: 2025年7月14日</div>
        </div>
      </div>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        <div className="bg-slate-900/50 backdrop-blur-sm border border-cyan-500/20 rounded-lg p-8 shadow-xl">
          {/* Title */}
          <div className="mb-12 text-center">
            <h1 className="text-4xl font-bold text-cyan-400 mb-4">
              利用規約
            </h1>
            <p className="text-sm text-white/60 uppercase tracking-wider">
              TERMS OF SERVICE
            </p>
          </div>

          {/* Preamble */}
          <div className="mb-12 bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
            <p className="mb-4">
              本利用規約（以下「本規約」といいます）は、Dig-Dim運営事務局（以下「当社」といいます）が提供する音楽プラットフォームサービス「Dig-Dim」（以下「本サービス」といいます）の利用条件を定めるものです。
            </p>
            <p className="mb-4">
              本サービスは、音楽アーティスト（以下「Maker」といいます）、音楽ファン（以下「Seeker」といいます）、および音楽関連店舗（以下「Node」といいます）が相互に交流し、イベントチケット、グッズ、その他のコンテンツを売買するためのCtoCプラットフォームです。
            </p>
            <p className="mb-4">
              当社は、ユーザー間の取引の場と決済システムを提供するものであり、売買契約の当事者とはなりません。ユーザーは本規約に同意の上、本サービスをご利用ください。
            </p>

            {/* ★ 3ページ統一の販売主体・決済代行者告知ボックス */}
            <div className="mt-4 border border-pink-500/60 rounded-lg bg-pink-500/10 p-5 relative overflow-hidden">
              <div className="absolute top-0 left-0 w-1 h-full bg-pink-500"></div>
              <div className="flex items-start gap-3 pl-2">
                <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-error-warning-fill text-pink-400 text-lg"></i>
                </div>
                <div className="space-y-3 w-full">
                  <p className="text-pink-300 font-bold text-sm">
                    【重要】販売主体および決済代行者について
                  </p>
                  <p className="text-white/80 text-sm leading-relaxed">
                    本サービスで販売されるイベントチケット・グッズ等の<strong className="text-white">販売者（売買契約の当事者）は、各Maker（アーティスト）またはNode（店舗・会場）</strong>です。Dig-Dim運営（当社）は、決済処理の代行者として取引を仲介しますが、販売主体ではありません。
                  </p>
                  <div className="bg-black/30 border border-pink-500/30 rounded p-3 space-y-2">
                    <p className="text-pink-200 text-xs font-bold">■ ご購入時の確認事項（購入完了メール・購入確認画面・特定商取引法ページにも同様に表示されます）</p>
                    <ul className="text-white/70 text-xs leading-relaxed space-y-1 list-disc pl-4">
                      <li>本チケット・商品の<strong className="text-white">販売者は各Maker/Node（主催者・出品者）</strong>です。Dig-Dim運営は決済代行者です。</li>
                      <li>カードの利用明細に「<strong className="text-white">Dig-Dim</strong>」と表示される場合がありますが、これは決済代行サービスの仕様によるものです。</li>
                      <li>購入された商品・サービスに関するお問い合わせは、各販売者または当社サポート窓口までご連絡ください。</li>
                      <li className="text-pink-300 font-bold">カード会社へのチャージバック申請を行う前に、必ず当社お問い合わせフォームよりご連絡いただきますようお願いいたします。</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Articles */}
          <div className="space-y-8">
            {/* Article 1 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第1条（適用範囲と変更）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  1.1 本規約は、本サービスの利用に関する当社とユーザーとの間の権利義務関係を定めることを目的とし、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されます。
                </p>
                <p>
                  1.2 当社は、ユーザーに事前の通知をすることなく、いつでも本規約を変更することができるものとします。変更後の本規約は、当社が別途定める場合を除いて、本サービス上に表示した時点より効力を生じるものとします。
                </p>
                <p>
                  1.3 ユーザーは、本規約の変更後も本サービスを継続して利用することにより、変更後の本規約に同意したものとみなされます。
                </p>
                <p>
                  1.4 本規約の最新版は、常に本ページ（本サービス内の利用規約ページ）に掲載されます。ユーザーは、本サービスを利用する前に本ページを確認し、最新の規約内容をご確認ください。
                </p>
                <p>
                  1.5 ユーザーの権利に重大な影響を与える変更（手数料率の変更、禁止事項の追加、免責範囲の拡大等）を行う場合、当社は変更の効力発生日の14日前までに、以下の方法のうち1つ以上の方法でユーザーに通知します。
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li><strong className="text-white">メール通知：</strong>登録メールアドレス宛に変更の概要および変更後の規約へのリンクを送信します。</li>
                  <li><strong className="text-white">サービス内通知：</strong>トップページまたはマイページにバナーまたはお知らせとして表示します。</li>
                  <li><strong className="text-white">本ページへの掲載：</strong>本規約ページの最終更新日を更新し、変更内容を反映します。</li>
                </ul>
                <p>
                  1.6 誤字・脱字の修正、条文番号の整理、法令改正に伴う軽微な文言調整など、ユーザーの権利義務に実質的な影響を与えない変更については、本ページへの掲載のみをもって通知に代えることができるものとします。
                </p>
                <p>
                  1.7 変更通知後も本サービスを継続して利用した場合、ユーザーは変更後の本規約に同意したものとみなされます。変更後の本規約に同意いただけない場合は、本サービスの利用を停止し、退会手続きを行ってください。退会に関するお問い合わせは、サポート窓口までご連絡ください。
                </p>
              </div>

              {/* 通知方法まとめボックス */}
              <div className="mt-5 border border-cyan-500/40 rounded-lg bg-cyan-500/10 p-5 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-1 h-full bg-cyan-500"></div>
                <div className="flex items-start gap-3 pl-2">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-notification-3-fill text-cyan-400 text-lg"></i>
                  </div>
                  <div className="space-y-3 w-full">
                    <p className="text-cyan-300 font-bold text-sm">
                      📢 規約変更時の通知方法（プライバシーポリシー・特定商取引法ページと統一）
                    </p>
                    <div className="grid grid-cols-1 gap-2">
                      <div className="bg-black/30 border border-cyan-500/20 rounded p-3">
                        <p className="text-cyan-200 text-xs font-bold mb-1">■ 重要な変更（14日前までに通知）</p>
                        <ul className="text-white/70 text-xs leading-relaxed space-y-1 list-disc pl-4">
                          <li>登録メールアドレス宛への<strong className="text-white">メール通知</strong>（変更概要＋規約リンク）</li>
                          <li>トップ/マイページへの<strong className="text-white">サービス内バナー通知</strong></li>
                          <li>本ページへの掲載（<strong className="text-white">最終更新日の更新</strong>）</li>
                        </ul>
                      </div>
                      <div className="bg-black/30 border border-cyan-500/20 rounded p-3">
                        <p className="text-cyan-200 text-xs font-bold mb-1">■ 軽微な変更（本ページ掲載のみ）</p>
                        <ul className="text-white/70 text-xs leading-relaxed space-y-1 list-disc pl-4">
                          <li>誤字・脱字の修正、条文番号の整理、法令改正に伴う文言調整など</li>
                        </ul>
                      </div>
                    </div>
                    <p className="text-white/60 text-xs">
                      変更通知後も本サービスを継続利用した場合、変更後の規約に同意したものとみなされます。
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* Article 2 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第2条（アカウント登録と自己責任）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  2.1 本サービスの利用を希望する者は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録情報」といいます）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。
                </p>
                <p>
                  2.2 当社は、当社の基準に従って、登録申請者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録申請者に通知します。登録申請者のユーザーとしての登録は、当社が本項の通知を行ったことをもって完了したものとします。
                </p>
                <p>
                  2.3 当社は、登録申請者が以下のいずれかの事由に該当する場合は、登録を拒否することがあります。
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>当社に提供した登録情報の全部または一部につき虚偽、誤記または記載漏れがあった場合</li>
                  <li>過去に本規約違反等により登録を抹消されたことがある場合</li>
                  <li>反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します）である、または資金提供その他を通じて反社会的勢力等の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与を行っていると当社が判断した場合</li>
                  <li>その他、当社が登録を適当でないと判断した場合</li>
                </ul>
                <p>
                  2.4 ユーザーは、自己の責任において、本サービスに関するアカウント情報（パスワードを含みます）を管理および保管するものとし、これを第三者に利用させさせ、貸与、譲渡、名義変更、売買等をしてはならないものとします。
                </p>
                <p>
                  2.5 アカウント情報の管理不十分、使用上の過誤、第三者の使用等による損害の責任はユーザーが負うものとし、当社は一切の責任を負いません。
                </p>
              </div>
            </section>

            {/* Article 3 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第3条（未成年者の利用）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  3.1 未成年者が本サービスを利用する場合は、法定代理人（親権者等）の同意を得た上で本サービスを利用するものとします。
                </p>
                <p>
                  3.2 未成年者のユーザーが、法定代理人の同意がないにもかかわらずあると偽り、または年齢について成年と偽って本サービスを利用した場合、その他行為能力者であることを信じさせるために詐術を用いた場合、本サービスに関する一切の法律行為を取り消すことはできません（民法第21条）。
                </p>
                <p>
                  3.3 本規約の同意時に未成年者であったユーザーが成年に達した後に本サービスを利用した場合、当該ユーザーは本サービスに関する一切の法律行為を追認したものとみなされます。
                </p>
              </div>
              <div className="mt-4 bg-red-500/10 border border-red-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-error-warning-line text-red-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-red-300">
                    <strong>重要：</strong>未成年者の方は、必ず法定代理人の同意を得てからご利用ください。同意を偽った場合、取り消しができません。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 4 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第4条（決済と手数料）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  4.1 本サービスにおける決済は、Stripe, Inc.が提供するStripe Connectを利用して行われます。ユーザーは、Stripeの利用規約およびプライバシーポリシーに同意の上、決済機能を利用するものとします。
                </p>
                <p>
                  4.2 当社は、本サービスの提供対価として、以下のプラットフォーム手数料を徴収します。
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>イベントチケット販売：販売価格の10%</li>
                  <li>グッズ販売：販売価格の15%</li>
                  <li>Resonance（投げ銭）：支援金額の5%</li>
                </ul>

                <p className="font-semibold text-white mt-4">4.3 販売者への分配時期と条件</p>
                <p>
                  販売者への売上金の支払いは、以下の条件をすべて満たした後に、販売者が登録した銀行口座へ振り込まれます。
                </p>
                <ol className="list-decimal list-inside ml-4 space-y-1">
                  <li>イベントチケット：イベント開催予定日の終了から3営業日が経過し、かつ購入者からの未開催報告がないこと。</li>
                  <li>物品（グッズ等）：購入者が本サービス上で受取確認を行った時点、または発送通知から14日が経過した時点。</li>
                  <li>Resonance：支援が行われた日の翌営業日以降（別途定める振込サイクルに従う）。</li>
                  <li><strong className="text-white">最低振込金額：</strong>振込可能残高が<strong className="text-cyan-300">1,000円（税込）以上</strong>に達した場合に限り、振込申請が可能となります。売上残高が1,000円未満の場合は振込申請を受け付けません。</li>
                </ol>

                <p className="font-semibold text-white mt-4">4.4 振込手数料の負担</p>
                <p>
                  売上金の振込にあたっては、前条の手数料とは別に、販売者の負担において<strong className="text-cyan-300">1回につき250円（税込）</strong>の振込手数料が発生します。当該手数料は振込実行時に振込可能残高から自動的に差し引かれます。なお、売上残高が振込手数料（250円）に満たない場合も振込を行うことができません。
                </p>

                <p>
                  4.5 イベントの中止や商品の契約不適合により返金が必要となった場合、当社は販売者の売上残高から返金原資を充当することができるものとし、販売者はこれに同意するものとします。
                </p>
              </div>

              {/* 振込条件まとめボックス */}
              <div className="mt-5 border border-cyan-500/40 rounded-lg bg-cyan-500/10 p-5 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-1 h-full bg-cyan-500"></div>
                <div className="flex items-start gap-3 pl-2">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-bank-card-fill text-cyan-400 text-lg"></i>
                  </div>
                  <div className="space-y-3 w-full">
                    <p className="text-cyan-300 font-bold text-sm">
                      💳 振込申請の条件まとめ（第4条 4.3・4.4）
                    </p>
                    <div className="grid grid-cols-1 gap-2">
                      <div className="bg-black/30 border border-cyan-500/20 rounded p-3">
                        <p className="text-cyan-200 text-xs font-bold mb-2">■ 振込申請が可能な条件</p>
                        <ul className="text-white/70 text-xs leading-relaxed space-y-1 list-disc pl-4">
                          <li>振込可能残高が <strong className="text-white">1,000円（税込）以上</strong> であること（第4条4.3(4)）</li>
                          <li>振込手数料として <strong className="text-white">250円（税込）</strong> が残高から自動差し引きされます（第4条4.4）</li>
                          <li>残高が振込手数料（250円）に満たない場合も申請不可</li>
                        </ul>
                      </div>
                      <div className="bg-black/30 border border-yellow-500/20 rounded p-3">
                        <p className="text-yellow-200 text-xs font-bold mb-2">■ 振込申請できない場合</p>
                        <ul className="text-white/70 text-xs leading-relaxed space-y-1 list-disc pl-4">
                          <li>売上残高が <strong className="text-yellow-300">1,000円未満</strong> の場合（利用規約第4条4.3(4)に基づき申請を受け付けません）</li>
                          <li>未履行の取引がある場合（第15条2項）</li>
                          <li>規約違反・不正行為が疑われる場合（第13条2項）</li>
                        </ul>
                      </div>
                    </div>
                    <p className="text-white/50 text-xs">
                      ※ 振込申請画面でも残高が1,000円未満の場合は申請ボタンが無効化されます。
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 bg-yellow-500/10 border border-yellow-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-alert-line text-yellow-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-yellow-300">
                    <strong>重要：</strong>イベント中止・商品の契約不適合による返金が必要な場合、当社は販売者の売上残高から返金原資を充当します。また、振込申請は<strong>売上残高が1,000円（税込）以上</strong>の場合にのみ可能で、振込手数料は1回250円（税込）が売上残高から自動差し引きされます。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 5 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第5条（インボイスと税務）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  5.1 本サービスを通じて収入を得たユーザー（販売者）は、自己の責任において、所得税、消費税その他の税金の申告および納付を行うものとします。当社は、ユーザーの税務申告を代行するものではありません。
                </p>
                <p>
                  5.2 適格請求書発行事業者として登録されているユーザーは、購入者から求められた場合、適格請求書（インボイス）を発行する責任を負います。当社は、ユーザーに代わって適格請求書を発行する義務を負いません。
                </p>
                <p>
                  5.3 免税事業者（適格請求書発行事業者として登録されていない事業者）は、適格請求書発行事業者登録番号を登録する必要はありません。ただし、取引先から適格請求書の発行を求められた場合、免税事業者である旨を説明する責任はユーザーにあります。
                </p>
                <p>
                  5.4 当社は、ユーザーの税務上の取り扱いについて、いかなる保証も行わず、また、税務申告に関する助言を行う義務を負いません。ユーザーは、必要に応じて税理士等の専門家に相談するものとします。
                </p>
              </div>
            </section>

            {/* Article 6 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第6条（プラットフォームの役割と売買契約）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  6.1 本サービスは、ユーザー間の取引の場と決済システムを提供するものであり、当社は売買契約その他の取引契約の当事者とはなりません。
                </p>
                <p>
                  6.2 イベントチケット、グッズその他のコンテンツの売買契約は、販売者と購入者との間で直接成立するものとし、当社は契約の成立、履行、契約不適合責任その他の契約上の責任を一切負いません。
                </p>
                <p>
                  6.3 販売者は、自己が販売する商品またはサービスについて、契約不適合責任（民法第562条以下）を含む一切の責任を負うものとします。
                </p>
                <p>
                  6.4 当社は、ユーザー間の取引に関して、商品の品質、安全性、適法性、正確性等について、いかなる保証も行いません。
                </p>
              </div>

              {/* ★ 3ページ統一の販売主体・決済代行者告知ボックス（第6条内） */}
              <div className="mt-6 border border-pink-500/60 rounded-lg bg-pink-500/10 p-5 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-1 h-full bg-pink-500"></div>
                <div className="flex items-start gap-3 pl-2">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-shield-check-fill text-pink-400 text-lg"></i>
                  </div>
                  <div className="space-y-2 w-full">
                    <p className="text-pink-300 font-bold text-sm">
                      🛡️ 販売主体・決済代行者の明確化（特定商取引法ページ・購入完了メール・購入確認画面と統一表記）
                    </p>
                    <ul className="text-white/75 text-xs leading-relaxed space-y-1 list-disc pl-4">
                      <li>
                        <strong className="text-white">販売者（売買契約の当事者）：各Maker（アーティスト）またはNode（店舗・会場）</strong>
                      </li>
                      <li>
                        <strong className="text-white">決済代行者：Dig-Dim運営事務局</strong>（当社はStripe Connectを通じて決済処理を代行します）
                      </li>
                      <li>
                        カードの利用明細に「Dig-Dim」と表示される場合がありますが、実際の販売者は各Maker/Nodeです。
                      </li>
                      <li className="text-pink-300 font-bold">
                        チャージバック申請の前に、必ず当社お問い合わせフォームよりご連絡ください。
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            {/* Article 7 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第7条（取引における個人情報の保護）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  7.1 販売者は、本サービスを通じて取得した購入者の個人情報（氏名、住所、電話番号、メールアドレス等）を、取引の履行（商品の発送、連絡等）の目的のみに使用するものとし、目的外の利用を行ってはなりません。
                </p>
                <p>
                  7.2 販売者は、購入者の個人情報を、購入者の同意なく第三者に提供、開示、漏洩してはなりません。
                </p>
                <p>
                  7.3 販売者は、購入者の個人情報を適切に管理し、不正アクセス、紛失、破壊、改ざん、漏洩等を防止するための措置を講じるものとします。
                </p>
                <p>
                  7.4 販売者が本条の規定に違反し、購入者または第三者に損害を与えた場合、販売者は自己の責任と費用においてこれを解決するものとし、当社は一切の責任を負いません。
                </p>
              </div>
              <div className="mt-4 bg-blue-500/10 border border-blue-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-information-line text-blue-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-blue-300">
                    <strong>重要：</strong>販売者は、購入者の個人情報を取引目的のみに使用し、目的外利用や第三者への提供を厳禁します。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 8 */}
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">第8条（キャンセル・返品・トラブル解決）</h2>
              
              <div className="mb-6">
                <h3 className="text-lg font-semibold text-cyan-300 mb-3">8.1 ユーザー都合によるキャンセル</h3>
                <p className="text-slate-300 mb-2">(1) 物品（グッズ等）については、原則として購入後のキャンセル・返品はできないものとします。</p>
                <p className="text-slate-300">(2) イベントチケットについては、販売者がイベント作成時に選択した特定のキャンセルポリシー（「24時間前まで」「7日前まで」等）が適用されるものとし、購入者は購入時に提示された当該ポリシーに同意したものとみなされます。</p>
              </div>

              <div className="mb-6 bg-pink-500/10 border border-pink-500/30 rounded-lg p-4">
                <h3 className="text-lg font-semibold text-pink-400 mb-3 flex items-center gap-2">
                  <i className="ri-alert-line"></i>
                  8.2 主催者都合によるイベント中止・不開催（★重要）
                </h3>
                <p className="text-slate-300 mb-2">(1) 主催者（NodeまたはMaker）の都合によりイベントが中止された場合、主催者は直ちに当社所定の方法で中止を報告し、購入者に対してチケット代金の全額を返金する義務を負います。</p>
                <p className="text-slate-300 mb-2">(2) イベント終了後、当社において「もぎ取り（スタンプ）」や「NFCチェックイン」のログが1件も確認できない場合、または多数の参加者から不開催の通報があった場合、当社は当該イベントを「不開催」と判定することができます。</p>
                <p className="text-slate-300">(3) 前二項の場合、当社は、販売者に代わり、当社が一時的に預かっている売上金を原資として購入者への返金処理を強制的に行うことができるものとし、販売者はこれに異議を唱えないものとします。</p>
              </div>

              <div className="mb-6">
                <h3 className="text-lg font-semibold text-cyan-300 mb-3">8.3 返品・交換（契約不適合責任）</h3>
                <p className="text-slate-300">商品に契約不適合（初期不良、説明との相違等）があった場合、購入者は販売者に対し、修補、代替物の引渡し、不足分の引渡し、代金減額、契約解除等を請求することができます。この際、販売者は自己の責任と費用において誠実に対応するものとします。</p>
              </div>

              <div className="mb-6">
                <h3 className="text-lg font-semibold text-cyan-300 mb-3">8.4 ユーザー間のトラブル解決</h3>
                <p className="text-slate-300">ユーザー間の取引に関するトラブルについては、当事者間で誠実に協議し、解決するものとします。ただし、詐欺的行為が疑われる場合やプラットフォームの社会的信用を著しく損なうと当社が判断した場合、当社は独自の判断で取引をキャンセルし、返金等の措置を講じる権利を有します。</p>
              </div>

              <div className="mb-6">
                <h3 className="text-lg font-semibold text-cyan-300 mb-3">8.5 当社の免責</h3>
                <p className="text-slate-300">当社は、ユーザー間のトラブルについて、当事者間の連絡を仲介することはありますが、解決を保証する義務を負わず、ユーザー間の紛争に起因する損害について一切の責任を負いません。</p>
              </div>
            </section>

            {/* Article 9 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第9条（知的財産権とコンテンツの利用許諾）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  9.1 ユーザーは、本サービスに投稿、アップロード、送信するコンテンツ（音楽、画像、動画、テキスト等。以下「投稿コンテンツ」といいます）について、自己が適法な権利を有していること、または必要な許諾を得ていることを保証するものとします。
                </p>
                <p>
                  9.2 ユーザーは、第三者の著作権、商標権、肖像権その他の知的財産権または人格権を侵害するコンテンツを投稿してはなりません。
                </p>
                <p>
                  9.3 ユーザーは、投稿コンテンツについて、当社に対し、本サービスの運営、プロモーション、改善、他のユーザーへの提供その他当社が必要と判断する目的において、無償かつ非独占的に利用（複製、翻案、公衆送信、展示、頒布、譲渡、貸与、翻訳、二次的著作物の作成を含みます）する権利を許諾するものとします。
                </p>
                <p>
                  9.4 ユーザーは、当社および当社から権利を承継しまたは許諾された者に対し、投稿コンテンツに関する著作者人格権（公表権、氏名表示権、同一性保持権）を行使しないものとします。
                </p>
                <p>
                  9.5 ユーザーが外部SNS（Instagram、YouTube、SoundCloud等）へのリンクを本サービスに掲載する場合、リンク先のコンテンツが適法であることを保証する責任はユーザーにあります。当社は、リンク先のコンテンツについて一切の責任を負いません。
                </p>
                <p>
                  9.6 当社は、投稿コンテンツが第三者の権利を侵害していると判断した場合、または法令に違反していると判断した場合、事前の通知なく当該コンテンツを削除することができるものとします。
                </p>
              </div>
              <div className="mt-4 bg-purple-500/10 border border-purple-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-information-line text-purple-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-purple-300">
                    <strong>重要：</strong>投稿コンテンツについて、当社はサービス運営・プロモーション目的で無償かつ非独占的に利用する権利を有します。また、著作者人格権を行使しないことに同意いただきます。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 10 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第10条（NFC/チェックイン機能の非保証）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  10.1 本サービスは、NFC（Near Field Communication）技術を利用したチェックイン機能を提供していますが、当社は、NFC機能の動作、精度、可用性について、いかなる保証も行いません。
                </p>
                <p>
                  10.2 NFC機能は、ユーザーの端末、通信環境、店舗の設備等の要因により、正常に動作しない場合があります。当社は、これらの要因による不具合について、一切の責任を負いません。
                </p>
                <p>
                  10.3 ユーザーが店舗においてNFC機能を利用する際に発生した物理的なトラブル（端末の破損、盗難、紛失等）について、当社は一切の責任を負いません。
                </p>
                <p>
                  10.4 当社は、NFC機能の提供を予告なく中断、変更、または終了することができるものとします。
                </p>
              </div>
            </section>

            {/* Article 11 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第11条（禁止事項）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  11.1 ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>法令または公序良俗に違反する行為</li>
                  <li>犯罪行為に関連する行為</li>
                  <li>当社または第三者の知的財産権、肖像権、プライバシー、名誉その他の権利または利益を侵害する行為</li>
                  <li>当社または第三者のサーバーまたはネットワークの機能を破壊したり、妨害したりする行為</li>
                  <li>本サービスの運営を妨害するおそれのある行為</li>
                  <li>不正アクセスをし、またはこれを試みる行為</li>
                  <li>他のユーザーに関する個人情報等を収集または蓄積する行為</li>
                  <li>他のユーザーに成りすます行為</li>
                  <li>当社のサービスに関連して、反社会的勢力に対して直接または間接に利益を供与する行為</li>
                  <li>当社、本サービスの他のユーザーまたは第三者に不利益、損害、不快感を与える行為</li>
                  <li>その他、当社が不適切と判断する行為</li>
                </ul>
              </div>
            </section>

            {/* Article 12 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第12条（反社会的勢力の排除）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  12.1 ユーザーは、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロまたは特殊知能暴力集団等、その他これらに準ずる者（以下これらを「反社会的勢力等」といいます）に該当しないこと、および次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約するものとします。
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>反社会的勢力等が経営を支配していると認められる関係を有すること</li>
                  <li>反社会的勢力等が経営に実質的に関与していると認められる関係を有すること</li>
                  <li>自己、自社もしくは第三者の不正の利益を図る目的または第三者に損害を加える目的をもってするなど、不当に反社会的勢力等を利用していると認められる関係を有すること</li>
                  <li>反社会的勢力等に対して資金等を提供し、または便宜を供与するなどの関与をしていると認められる関係を有すること</li>
                  <li>役員または経営に実質的に関与している者が反社会的勢力等と社会的に非難されるべき関係を有すること</li>
                </ul>
                <p>
                  12.2 ユーザーが前項の規定に違反した場合、当社は、何らの催告を要せず、直ちに本サービスの利用を停止し、またはユーザーとしての登録を抹消することができるものとします。
                </p>
                <p>
                  12.3 当社は、当社の都合により、本サービスの提供を終了することができるものとします。この場合、当社は、ユーザーに対し、終了の30日前までに通知するものとします。
                </p>
                <p>
                  12.4 当社は、本条に基づき当社が行った措置によりユーザーに生じた損害について、一切の責任を負いません。
                </p>
              </div>
            </section>

            {/* Article 13 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第13条（利用制限および売上金の没収）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  13.1 当社は、ユーザーが以下のいずれかに該当する場合、事前の通知なく、ユーザーに対して、本サービスの全部もしくは一部の利用を制限し、またはユーザーとしての登録を抹消することができるものとします。
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>本規約のいずれかの条項に違反した場合</li>
                  <li>登録情報に虚偽の事実があることが判明した場合</li>
                  <li>未成年者が法定代理人の同意を得ずに本サービスを利用していることが判明した場合</li>
                  <li>料金等の支払債務の不履行があった場合</li>
                  <li>当社からの連絡に対し、一定期間返答がない場合</li>
                  <li>本サービスについて、最終の利用から一定期間利用がない場合</li>
                  <li>第12条各項に該当する場合</li>
                  <li>その他、当社が本サービスの利用を適当でないと判断した場合</li>
                </ul>
                <p>
                  13.2 当社は、ユーザーが本規約に違反し、または詐欺行為、不正行為その他の不法行為を行ったと判断した場合、当該ユーザーの売上金（本サービスを通じて得た収入のうち、当社がまだ支払っていないもの）の支払いを留保し、または没収することができるものとします。
                </p>
                <p>
                  13.3 前項により没収された売上金は、当社が被った損害の賠償、被害を受けた他のユーザーへの返金、その他当社が適切と判断する用途に充当することができるものとします。
                </p>
                <p>
                  13.4 当社は、本条に基づき当社が行った行為によりユーザーに生じた損害について、一切の責任を負いません。
                </p>
              </div>
              <div className="mt-4 bg-red-500/10 border border-red-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-error-warning-line text-red-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-red-300">
                    <strong>重要：</strong>規約違反や詐欺行為が発覚した場合、売上金の支払いを留保し、損害賠償や被害者への返金に充当するため没収することがあります。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 14 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第14条（本サービスの変更、中断、終了）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  14.1 当社は、以下のいずれかの事由があると判断した場合、ユーザーに事前に通知することなく本サービスの全部または一部の提供を中断または中止することができるものとします。
                </p>
                <ul className="list-disc list-inside ml-4 space-y-1">
                  <li>本サービスにかかるコンピュータシステムの保守点検または更新を行う場合</li>
                  <li>地震、落雷、火災、停電または天災などの不可抗力により、本サービスの提供が困難となった場合</li>
                  <li>コンピュータまたは通信回線等が事故により停止した場合</li>
                  <li>その他、当社が本サービスの提供が困難と判断した場合</li>
                </ul>
                <p>
                  14.2 当社は、当社の都合により、本サービスの提供を終了することができるものとします。この場合、当社は、ユーザーに対し、終了の30日前までに通知するものとします。
                </p>
                <p>
                  14.3 当社は、本条に基づき当社が行った措置によりユーザーに生じた損害について、一切の責任を負いません。
                </p>
              </div>
              <div className="mt-4 bg-yellow-500/10 border border-yellow-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-alert-line text-yellow-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-yellow-300">
                    <strong>重要：</strong>メンテナンス、不可抗力、当社の都合によりサービスを中断・終了する場合があります。終了時は30日前に通知します。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 15 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第15条（退会）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  15.1 ユーザーは、当社の定める方法により、本サービスから退会することができます。
                </p>
                <p>
                  15.2 ユーザーは、未履行の取引（発送待ちの商品、未開催のイベント等）がある場合、または当社に対する債務（未払いの手数料、損害賠償債務等）がある場合は、退会することができません。
                </p>
                <p>
                  15.3 退会後も、ユーザーは、退会前に行った取引に関する責任（契約不適合責任、損害賠償責任等）を免れるものではありません。
                </p>
                <p>
                  15.4 当社は、退会後も、法令に基づく保存義務がある場合、または紛争解決のために必要な場合、ユーザーの情報を保持することができるものとします。
                </p>
              </div>
              <div className="mt-4 bg-red-500/10 border border-red-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-error-warning-line text-red-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-red-300">
                    <strong>重要：</strong>未履行の取引や残債務がある場合は退会できません。退会後も取引に関する責任は継続します。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 16 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第16条（保証の否認および損害賠償の制限）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  16.1 当社は、本サービスがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、ユーザーによる本サービスの利用がユーザーに適用のある法令または業界団体の内部規則等に適合すること、および不具合が生じないことについて、いかなる保証も行うものではありません。
                </p>
                <p>
                  16.2 当社は、本サービスに関してユーザーが被った損害について、当社に故意または重過失がある場合を除き、一切の責任を負いません。
                </p>
                <p>
                  16.3 当社に故意または重過失がある場合であっても、当社がユーザーに対して負う損害賠償責任の範囲は、直接の原因となった取引において、当該ユーザーが過去3ヶ月間に当社に支払ったプラットフォーム手数料の総額、または1万円のいずれか高い金額を上限とします。
                </p>
                <p>
                  16.4 当社は、本サービスに関してユーザーが被った間接損害、特別損害、将来の損害、逸失利益について、当社が当該損害の可能性を事前に通知されていた場合であっても、一切の責任を負いません。
                </p>
                <p>
                  16.5 ユーザー間の取引に関するトラブルについて、当社は一切の責任を負いません。
                </p>
              </div>
              <div className="mt-4 bg-yellow-500/10 border border-yellow-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-alert-line text-yellow-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-yellow-300">
                    <strong>重要：</strong>当社に故意・重過失がある場合を除き、損害賠償の上限は「過去3ヶ月間の手数料総額または1万円のいずれか高い額」です。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 17 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第17条（分離可能性）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  17.1 本規約のいずれかの条項またはその一部が、消費者契約法その他の法令等により無効または執行不能と判断された場合であっても、本規約の残りの規定および一部が無効または執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。
                </p>
                <p>
                  17.2 前項の場合、当社およびユーザーは、当該無効または執行不能とされた条項の趣旨に最も近い有効な条項をもってこれに代えることに合意するものとします。
                </p>
              </div>
            </section>

            {/* Article 18 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第18条（通知および連絡）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  18.1 本サービスに関する当社からユーザーへの通知または連絡は、当社の定める方法（電子メール、本サービス内の通知機能等）によって行うものとします。
                </p>
                <p>
                  18.2 当社が、ユーザーの登録情報に含まれるメールアドレス宛に電子メールを送信した場合、当該電子メールは、通常到達すべき時期に到達したものとみなされます。
                </p>
                <p>
                  18.3 ユーザーは、登録情報に変更があった場合、速やかに当社の定める方法により変更の届出を行うものとします。変更の届出がなされなかったことによりユーザーに生じた損害について、当社は一切の責任を負いません。
                </p>
              </div>
              <div className="mt-4 bg-blue-500/10 border border-blue-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-information-line text-blue-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-blue-300">
                    <strong>重要：</strong>当社から登録メールアドレス宛に通知を送信した時点で、通常到達すべき時期に到達したものとみなされます。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 19 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第19条（権利義務の譲渡禁止）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  19.1 ユーザーは、当社の書面による事前の承諾なく、本規約に基づく権利もしくは義務、または本サービスに関する契約上の地位について、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。
                </p>
                <p>
                  19.2 ユーザーは、当社に対する債権（売上金の支払請求権を含みます）を、第三者に譲渡し、または担保に供することはできません。
                </p>
                <p>
                  19.3 当社は、本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い本規約上の地位、本規約に基づく権利および義務ならびにユーザーの登録情報その他の顧客情報を当該事業譲渡の譲受人に譲渡することができるものとし、ユーザーは、かかる譲渡につき本項において予め同意したものとします。
                </p>
              </div>
              <div className="mt-4 bg-purple-500/10 border border-purple-500/30 p-4 rounded-lg">
                <div className="flex items-start gap-2">
                  <i className="ri-information-line text-purple-400 text-lg mt-0.5"></i>
                  <div className="text-sm text-purple-300">
                    <strong>重要：</strong>アカウントや当社に対する債権（売上金請求権など）を第三者に譲渡することはできません。
                  </div>
                </div>
              </div>
            </section>

            {/* Article 20 */}
            <section className="bg-white/5 border border-white/10 p-6 rounded-lg leading-relaxed">
              <h2 className="text-2xl font-bold text-cyan-400 mb-4">
                第20条（準拠法および管轄裁判所）
              </h2>
              <div className="space-y-3 text-sm">
                <p>
                  20.1 本規約の解釈にあたっては、日本法を準拠法とします。
                </p>
                <p>
                  20.2 本サービスに関して紛争が生じた場合には、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
                </p>
              </div>
            </section>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t border-white/10 text-center">
            <p className="text-sm text-white/60 mb-4">
              本規約に関するご質問は、
              <Link to="/contact" className="text-cyan-400 hover:text-cyan-300 underline ml-1">
                お問い合わせフォーム
              </Link>
              よりご連絡ください。
            </p>
            <p className="text-xs text-white/40">
              © 2024 Dig-Dim運営事務局. All rights reserved.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}